<div *ngIf="auctionBid$ | async as purchasedItem; else noItem">
  <div class="marketplace-wallet-item-list">
    <div class="item-container">
      <fgbcl-rewards-wallet-redeem-list-item
        [item]="purchasedItem"
        [multi]="false"
        [showButton]="false"
        orientation="landscape"
      ></fgbcl-rewards-wallet-redeem-list-item>
    </div>
  </div>

  <div class="loyalty-details w-100 mt-4">
    <!-- Details -->
    <h5 class="item-details-title">{{ 'auction.wallet.details.item.title' | translate }}</h5>

    <div class="wallet-details-container">
      <!-- Points -->
      <div class="wallet-details-item wallet-points-value">
        <div class="wallet-details-item-label">{{ 'fgbcl.rewards.wallet.points' | translate }}</div>
        <div class="wallet-details-item-value">
          {{ purchasedItem.PointValue | FortressCurrencyPipe: 'PTS' }}
        </div>
      </div>
    </div>
    <!-- Card Body -->
    <div class="accordion accordion-flush" id="marketplace-wallet-accordion">
      <div class="accordion-item">
        <h2 class="accordion-header" id="accordion-desc-heading">
          <button
            class="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#accordion-desc"
            aria-expanded="true"
            aria-controls="accordion-desc"
          >
            {{ 'fgbcl.rewards.wallet.description' | translate }}
          </button>
        </h2>
        <div id="accordion-desc" class="accordion-collapse collapse show" aria-labelledby="accordion-desc-heading">
          <div class="accordion-body">
            <fgbcl-short-long-description [description]="purchasedItem.Description"> </fgbcl-short-long-description>
          </div>
        </div>
      </div>

      <!--Terms-->
      <ng-container *ngIf="purchasedItem.TermsAndConditions">
        <div class="accordion-item">
          <h2 class="accordion-header" id="accordion-terms-heading">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#accordion-terms"
              aria-expanded="false"
              aria-controls="accordion-terms"
            >
              {{ 'fgbcl.rewards.wallet.terms' | translate }}
            </button>
          </h2>
          <div id="accordion-terms" class="accordion-collapse collapse" aria-labelledby="accordion-terms-heading">
            <div class="accordion-body">
              <fgbcl-short-long-description [description]="purchasedItem.TermsAndConditions"> </fgbcl-short-long-description>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #noItem>
  <div class="text-center m-5">
    <i>{{ 'wallet.no.items.found' | translate }}</i>
  </div>
</ng-template>
